<template>
  <div class="shop-detail-page">
    <div class="ceiling">
      <HomeTop></HomeTop>
      <navicat :current="-1"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="bread-crumb w-1400">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/shop' }">商城</el-breadcrumb-item>
        <el-breadcrumb-item>{{ detail.product_name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 顶部大图和基础信息 -->
    <div class="content-body-top w-1400" v-loading="loading">
      <div class="bottom-body">
        <!-- 商品图片 -->
        <div class="left-image">
          <el-image :src="detail.image" fit="contain" class="main-image"/>
        </div>
        <div class="right-inner">
          <h1 class="product-title">
            {{ detail.product_name }}
            <el-badge :value="carNum" class="cart-badge" type="danger">
              <div class="cart-btn" @click="handleCar">
                <i class="el-icon-s-goods"></i>
                购物车
              </div>
            </el-badge>
          </h1>
          <!-- 规格选择 -->
          <template v-if="detail.spec_type==1">
            <div class="spec-section" v-for="sku in detail.attr" :key="sku.id">
              <div class="spec-label">{{ sku.name }}：</div>
              <el-radio-group v-model="selectedSku[sku.id]" class="spec-radio-group" @change="handleSpecChange">
                <el-radio v-for="(spec, idx) in sku.attrvalue" :key="spec.id" :label="spec.name">{{
                    spec.name
                  }}
                </el-radio>
              </el-radio-group>
            </div>
          </template>


          <template v-else-if="detail.spec_type!=1&&detail.spec_sku">
            <div class="spec-section">
              <div class="spec-label">重量：</div>
              <div>
                <el-tag>{{ detail.spec_sku.split(',')[1] }}</el-tag>
              </div>

            </div>
            <div class="spec-section">
              <div class="spec-label">纯度：</div>
              <div>
                <el-tag>{{ detail.spec_sku.split(',')[0] }}</el-tag>
              </div>

            </div>
          </template>

          <!-- 价格、数量、操作按钮区域 -->
          <div class="price-stock">
            <span class="price">单价：￥{{ price }} <span class="vip-price" v-if="isVip">￥{{ vipPrice }}</span></span>
            <el-input-number v-model="buyNum" :min="1" class="buy-num-input" size="medium"/>
          </div>
          <div class="purchase-section">

            <div class="flex-inner">
              <div>
                <span class="total-label">小计:</span>
                <span class="total-amount">￥{{ (price * buyNum).toFixed(2) }}</span>
              </div>
              <div class="action-btns">
                <el-button class="btn-primary" type="primary" @click="addToCart">加入购物车</el-button>
                <el-button class="btn-success" type="success" @click="buyNow">立即购买</el-button>
              </div>
            </div>
          </div>

        </div>


      </div>
      <div class="right-info">
        <!-- 商品基础信息表格 -->
        <table class="base-info-table" v-if="detail.product">
          <tr>
            <th>CAS号</th>
            <td>{{ detail.cas_no || "--" }}</td>
            <th>分子式</th>
            <td>{{ detail.product.fenzishi || "--" }}</td>
          </tr>
          <tr>
            <th>分子量</th>
            <td>{{ detail.product.fenziliang || "--" }}</td>
            <th>中文别名</th>
            <td>{{ detail.product.alias_name || "--" }}</td>
          </tr>
          <tr>
            <th>英文名</th>
            <td>{{ detail.product.name_en || "--" }}</td>
            <th>英文别名</th>
            <td>{{ detail.product.alias_name_en || "--" }}</td>
          </tr>
          <tr>
            <th>外观</th>
            <td colspan="3">{{ detail.product.appearance || "--" }}</td>

          </tr>
        </table>
      </div>

    </div>
    <!-- 详细信息Tab -->
    <div class="content-body-bottom w-1400">
      <div class="classfily-box">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item :index="item.index" v-for="item in tarBarList" :key="item.id">{{ item.name }}</el-menu-item>
        </el-menu>
      </div>
      <div class="classfily-body" v-if="detail.product">
        <div class="inner-box" v-if="activeIndex == '3'">
          <div class="inner-box-title">物理化学性质</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.properties">
              <!--              {{ detail.product.properties }}-->
            </div>
            <el-empty v-if="!detail.product.properties" description="暂无生产用途"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '4'">
          <div class="inner-box-title">生产用途</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.usag">
              <!--              {{ detail.product.usag }}-->
            </div>
            <el-empty v-if="!detail.product.usag" description="暂无生产用途"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '5'">
          <div class="inner-box-title">毒性和生态</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.toxicity_ecology ">
            </div>
            <el-empty v-if="!detail.product.toxicity_ecology" description="暂无毒性和生态"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '6'">
          <div class="inner-box-title">安全信息</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.safe_information">
              <!--              {{ detail.product.safe_information }}-->
            </div>
            <el-empty v-if="!detail.product.safe_information" description="暂无安全信息"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '7'">
          <div class="inner-box-title">MSDS</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.MSDS">
              <!--              {{ detail.product.MSDS }}-->
            </div>
            <el-empty v-if="!detail.product.MSDS" description="暂无MSDS"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '8'">
          <div class="inner-box-title">上下游产品</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.up_product">
              <!--              {{ detail.product.up_product }}-->
            </div>
            <el-empty v-if="!detail.product.up_product" description="暂无上下游产品"/>
          </div>
        </div>
        <div class="inner-box" v-if="activeIndex == '9'">
          <div class="inner-box-title">海关数据</div>
          <div class="inner-box-content">
            <div class="inner-box-content-item" v-html="detail.product.customs_data">
              <!--              {{ detail.product.customs_data }}-->
            </div>
            <el-empty v-if="!detail.product.customs_data" description="暂无海关数据"/>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="right-box-fixed hit-cursor" @click="handleCar">
      <el-badge :value="carNum" class="item">
        <img
          src="../../../static/index/shop/car.png"
          alt="购物车图片"
          class="car-img"
        />
      </el-badge>
    </div> -->
  </div>
</template>

<script>
import HomeTop from "@/components/public/home-top.vue";
import Navicat from "@/components/navicat/navicat.vue";
import {detailApi, shop_cart, shop_cart_list} from "@/api/modules/home";

export default {
  components: {
    HomeTop,
    Navicat,
  },
  name: "ShopDetail",
  data() {
    return {
      carNum: 0,
      activeIndex: "3",
      id: this.$route.query.id,
      vipPrice: 0,
      tarBarList: [
        {
          name: "物理化学性质",
          index: "3",
        },
        {
          name: "生产用途",
          index: "4",
        },
        {
          name: "毒性和生态",
          index: "5",
        },
        {
          name: "安全信息",
          index: "6",
        },
        {
          name: "MSDS",
          index: "7",
        },
        {
          name: "上下游产品",
          index: "8",
        },
        {
          name: "海关数据",
          index: "9",
        },
      ],
      baseTable: [],
      selectedSpec: {},
      buyNum: 1,
      selectTab: "phychem",
      recommendList: [],
      detail: {},
      selectedSku: {},
      price: 0,
      loading: false,
    };
  },
  computed: {
    isVip() {
      return this.$store.getters.is_vip;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    }
  },
  mounted() {
    this.getDetail();
    this.getCarNum();
  },
  methods: {
    // 获取购物车数量
    getCarNum() {
      shop_cart_list().then((res) => {
        this.carNum = res.data.data.total;
      });
    },
    // 跳转购物车
    handleCar() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      this.$router.push("/shop/car");
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    // 规格选择
    handleSpecChange(e) {
      this.changeSku();
    },
    // 规格选择
    changeSku() {
      let getSkuList = JSON.parse(JSON.stringify(this.selectedSku))
      let data = Object.values(getSkuList).join(",");
      if (this.detail.spec_type == 1 && this.detail.sku.length > 0) {

        let inner = this.detail.sku.find((item) => {
          return item.sku == data
        });
        this.price = this.isVip ? inner.baojia_price : inner.price;
        this.vipPrice = inner.price;
      } else {
        this.price = this.isVip ? this.detail.baojia_price : this.detail.price;
        this.vipPrice = this.detail.price;
      }
    },
    addToCart() {
      // 加入购物车逻辑
      shop_cart({
        shop_product_id: Number(this.id),
        cart_num: this.buyNum,
        sku: Object.values(this.selectedSku).join(","),
      }).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: "加入购物车成功",
            duration: 2000,
            offset: 300,
          });
        } else {
          this.$message.error({
            message: res.data.msg,
            duration: 2000,
            offset: 300,
          });
        }
        this.getCarNum();
      });
    },
    buyNow() {
      // 立即购买逻辑
      let data;
      if (this.detail.spec_type == 1) {
        data = [
          {
            product_name: this.detail.product_name,
            cas_no: this.detail.cas_no,
            sku: Object.values(this.selectedSku).join(","),
            purity: Object.values(this.selectedSku)[1],
            weight: Object.values(this.selectedSku)[0],
            custorm_price: this.price,
            num: this.buyNum,
            id: this.detail.id,
            supply_id: this.detail.user_id,
          },
        ];
      } else {
        data = [
          {
            product_name: this.detail.product_name,
            cas_no: this.detail.cas_no,
            sku: this.detail.spec_sku,
            custorm_price: this.detail.price,
            purity: this.detail.spec_sku.split(",")[0],
            weight: this.detail.spec_sku.split(",")[1],
            supply_id: this.detail.user_id,
            num: this.buyNum,
            id: this.detail.id,
          },
        ];
      }
      // 将data存储到vuex中
      this.$store.commit("SET_SETTLEMENT_LIST", data);
      // 立即购买
      this.$router.push({
        path: "/shop/settlement",
        query: {
          type: this.detail.sort == 1 ? "more" : "one",
          // selectedList: JSON.stringify(data),
        },
      });
    },
    getDetail() {
      this.loading = true;
      detailApi(this.id).then((res) => {
        this.detail = res.data.data;
        this.loading = false;
        if (this.detail.sort == 2) {
          let sku = this.detail.spec_sku.split(",")
          if (sku.length == 1) {
            this.detail.attr.push({
              name: "重量",
              id: 1,
              attrvalue: [{name: this.detail.spec_sku.split(",")[0]}],
            },)
          } else {
            this.detail.attr = [
              {
                name: "重量",
                id: 1,
                attrvalue: [{name: this.detail.spec_sku.split(",")[0]}],
              },
              {
                name: "纯度",
                id: 2,
                attrvalue: [{name: this.detail.spec_sku.split(",")[1]}],
              },
            ];
          }

        }
        this.detail.attr.forEach((item) => {
          this.selectedSku[item.id] = item.attrvalue[0].name;
        });
        this.changeSku();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.right-box-fixed {
  position: fixed;
  top: 50vh;
  right: 0;
  padding-right: 10px;
  border-radius: 6px 0 0 6px;

  .car-img {
    width: 40px;
    height: 40px;
  }
}

.content-body-bottom {
  padding-top: 40px;
  margin-bottom: 40px;

  .classfily-box {
    background: #ffffff;
    padding: 0 100px;
    margin-bottom: 10px;
  }

  .classfily-body {
    background: #ffffff;

    .inner-box {
      padding: 20px;

      ::v-deep .el-select {
        width: 100%;
      }

      .inner-box-title {
        font-weight: bold;
        font-size: 20px;
        color: #00112b;
        padding-bottom: 20px;
        margin-left: 40px;
        margin-bottom: 20px;
        border-bottom: 1px solid #f5f5f5;

        // line-height: 68px;
      }

      .btn-box {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}

.h-top {
  // height: 157px;
  height: 120px;
}

.bread-crumb {
  padding: 20px 0;
}

.shop-detail-page {
  background: #f6f7f8;
  min-height: 100vh;

  .content-body-top {

    padding: 40px 30px 30px;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;

    .left-image {
      width: 400px;

      .main-image {
        width: 100%;
        height: 320px;
        border-radius: 12px;
        box-shadow: 0 4px 24px rgba(64, 158, 255, 0.08);
        background: #fff;
      }

      .thumb-list {
        display: flex;
        gap: 10px;
        margin-top: 12px;

        .thumb {
          width: 60px;
          height: 60px;
          border-radius: 8px;
          border: 1px solid #eee;
          cursor: pointer;

          &:hover {
            border-color: #409eff;
          }
        }
      }
    }

    .bottom-body {
      display: flex;
      gap: 40px;
      padding-bottom: 24px;

      .right-inner {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }

      .spec-section {
        margin-bottom: 18px;
        display: flex;

        .spec-label {
          font-weight: 600;
          margin-right: 10px;
        }

        .spec-radio-group {
          display: inline-flex;
          gap: 10px;
        }
      }

      .flex-inner {
        display: flex;
        justify-content: space-between;
      }

      .total-label {
        font-size: 18px;
        color: #888;
      }

      .total-amount {
        font-size: 28px;
        font-weight: 800;
        color: #ff4d4f;
        margin-left: 4px;
        letter-spacing: 1px;
      }

      .price-stock {
        display: flex;
        justify-content: space-between;
        gap: 18px;
        margin-bottom: 0;
        flex-wrap: wrap;
        align-items: center;

        .price {
          font-size: 20px;
          color: #409eff;

          .vip-price {
            font-size: 16px;
            color: #666666;
            text-decoration: line-through;
          }
        }

        .buy-num-input {
          width: 110px;
          margin: 0 8px;

          .el-input__inner {
            font-size: 16px;
          }
        }


      }

      .purchase-section {
        margin: 24px 0 0 0;


        .action-btns {
          display: flex;
          gap: 18px;

          .el-button {
            min-width: 140px;
            font-size: 16px;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
            transition: all 0.2s;
          }

          .el-button--primary {
            background: #ff943e;
            border: none;
            color: #fff;
          }

          .el-button--success {
            background: #409eff;
            border: none;
            color: #fff;
          }

          .el-button:hover {
            // transform: translateY(-2px) scale(1.03);
            box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
          }
        }
      }

      .product-title {
        font-size: 28px;
        font-weight: 700;
        color: #222;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;

        .cart-badge {
          margin-left: 18px;

          .el-badge__content {
            font-size: 14px;
            min-width: 22px;
            height: 22px;
            line-height: 22px;
            background: #ff4d4f;
            color: #fff;
            box-shadow: 0 2px 8px rgba(255, 77, 79, 0.15);
          }

          .cart-btn {
            display: flex;
            align-items: center;
            background: #fff;
            border: 1.5px solid #409eff;
            border-radius: 20px;
            padding: 0 18px;
            height: 40px;
            font-size: 16px;
            color: #409eff;
            font-weight: 600;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
            cursor: pointer;
            transition: all 0.2s;

            .car-img {
              width: 26px;
              height: 26px;
              margin-right: 8px;
              transition: transform 0.2s;
            }

            &:hover {
              background: #f0f8ff;
              border-color: #66b1ff;

              .car-img {
                transform: scale(1.15) rotate(-10deg);
              }
            }
          }
        }
      }


    }

    .right-info {
      flex: 1;


      .base-info-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 18px;

        th,
        td {
          padding: 8px;
          text-align: left;
          border-bottom: 1px solid #eee;
          word-break: break-all;
          /* 允许在任意字符处断开 */
          word-wrap: break-word;
          /* 允许在单词内断开 */
        }

        th {
          width: 150px;
          text-align: center;
          background-color: #f8f9fa;
        }

        td:nth-child(2) {
          width: 150px;
          padding: 0 20px;
        }

        td:nth-child(4) {
          padding: 8px 20px;
        }
      }


    }
  }
}

@media (max-width: 600px) {
  .purchase-section {
    flex-direction: column;
    align-items: stretch;

    .price-stock,
    .action-btns {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .price-stock {
      .total-amount {
        font-size: 24px;
        margin-top: 4px;
      }
    }

    .action-btns .el-button {
      min-width: 100px;
      width: 100%;
    }
  }
}
</style>
